import { DialogContent, DialogTitle, Typography } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { DeleteDialog } from "../../components";
import { deleteFavourite } from "../../ducks/actions";
import { useActionRequest } from "../../hooks";

const DeleteEposterFavouritesDialog = ({ id, onClose }) => {
  const intl = useIntl();

  const deleteFavouriteRequest = useActionRequest({
    action: deleteFavourite
  });
  const onDeleteFavourite = () => {
    deleteFavouriteRequest({ id });
    onClose();
  };

  return (
    <DeleteDialog onClose={onClose} onDelete={onDeleteFavourite}>
      <DialogTitle>
        {intl.formatMessage({
          id: "Eposters.DeleteFavouritesDialog.Title",
          defaultMessage: "Remove favourite..."
        })}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body2">
          {intl.formatMessage({
            id: "Eposters.DeleteFavouritesDialog.Message",
            defaultMessage: "Are you sure you want to remove this favourite?"
          })}
        </Typography>
      </DialogContent>
    </DeleteDialog>
  );
};

export default DeleteEposterFavouritesDialog;
